// extracted by mini-css-extract-plugin
export var displayNone = "_jd-6";
export var imgContainer = "_jd-2";
export var overflowHidden = "_jd-3";
export var productInfoCardButtonContainer = "_jd-5";
export var productTitleText = "_jd-4";
export var rightArrow = "_jd-1";
export var rightArrowContainer = "_jd-0";